import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function InstructionQuestionIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 4.25C2 3.97386 2.22386 3.75 2.5 3.75H13.5C13.7761 3.75 14 3.97386 14 4.25C14 4.52614 13.7761 4.75 13.5 4.75H2.5C2.22386 4.75 2 4.52614 2 4.25Z'
        fill='#3E8FFA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 6.75C2 6.47386 2.22386 6.25 2.5 6.25H10.5C10.7761 6.25 11 6.47386 11 6.75C11 7.02614 10.7761 7.25 10.5 7.25H2.5C2.22386 7.25 2 7.02614 2 6.75Z'
        fill='#3E8FFA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 9.25C2 8.97386 2.22386 8.75 2.5 8.75H13.5C13.7761 8.75 14 8.97386 14 9.25C14 9.52614 13.7761 9.75 13.5 9.75H2.5C2.22386 9.75 2 9.52614 2 9.25Z'
        fill='#3E8FFA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 11.75C2 11.4739 2.22386 11.25 2.5 11.25H10.5C10.7761 11.25 11 11.4739 11 11.75C11 12.0261 10.7761 12.25 10.5 12.25H2.5C2.22386 12.25 2 12.0261 2 11.75Z'
        fill='#3E8FFA'
      />
    </SvgIcon>
  );
}
